/**
 * Z-Index 层级管理
 * 用于统一管理应用中所有组件的层级关系
 *
 * 层级规则：
 * 1. 基础内容: 1-100
 * 2. 卡片/面板: 100-200
 * 3. 下拉菜单: 200-300
 * 4. 工具提示: 300-400
 * 5. 模态框: 400-500
 * 6. 通知/Toast: 500-600
 * 7. 加载状态: 600-700
 * 8. 错误边界: 700-800
 * 9. 调试工具: 800-900
 * 10. 最高层级: 900+
 */

export const Z_INDEX = {
	// 基础内容
	BASE: 1,
	CONTENT: 10,
	CARD: 50,

	// 交互元素
	DROPDOWN: 200,
	TOOLTIP: 300,

	// 模态框和覆盖层
	MODAL: 400,
	MODAL_OVERLAY: 450,

	// 通知和提示
	TOAST: 500,
	NOTIFICATION: 550,

	// 加载和状态
	LOADING: 600,
	LOADING_OVERLAY: 650,

	// 错误和调试
	ERROR_BOUNDARY: 700,
	DEBUG_TOOLS: 800,

	// 最高层级
	MAXIMUM: 9999,
	ULTIMATE: 99999,
} as const;

export type ZIndexKey = keyof typeof Z_INDEX;

/**
 * 获取z-index值
 * @param key z-index键名
 * @returns z-index数值
 */
export const getZIndex = (key: ZIndexKey): number => {
	return Z_INDEX[key];
};

/**
 * 获取自定义z-index值
 * @param value 自定义数值
 * @returns z-index字符串
 */
export const getCustomZIndex = (value: number): string => {
	return `z-[${value}]`;
};

export default Z_INDEX;
